var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnpin28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#unpin_28-a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.677 10.868c1.255-.18 1.767-1.715.87-2.612l-5.803-5.804c-.897-.896-2.433-.384-2.612.871L17.035 4a4.104 4.104 0 0 1-1.16 2.322l-1.57 1.57-.031.03 5.804 5.804.03-.03 1.57-1.57A4.104 4.104 0 0 1 24 10.965l.677-.097ZM8.493 9.296l-2.12-2.12a1.275 1.275 0 1 1 1.804-1.803l14.45 14.45a1.275 1.275 0 1 1-1.804 1.803l-2.12-2.12-.214 3.222c-.083 1.24-1.526 1.876-2.497 1.1l-4.954-3.964-7.186 5.88a1.134 1.134 0 0 1-1.596-1.596l5.88-7.186-3.963-4.954c-.777-.97-.141-2.414 1.1-2.497l3.22-.215Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "unpin_28-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin28);
export default __webpack_public_path__ + "static/media/unpin_28.2a8df766.svg";
export { ForwardRef as ReactComponent };